import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const convertToDataTable = (data: IGetCostBy[]): IGetCostBy[] => {
  const dataTableData: IGetCostBy[] = [];

  if(!data) return dataTableData;

  data.map(d => {
    dataTableData.push(d)
  })

  return dataTableData;
}

const getAllCostByList = async (): Promise<IGetCostBy[]> => {
  const response =  await axiosDefaultApi.get(`/api/CostBy/GetCostBy`);
  return convertToDataTable(response as unknown as IGetCostBy[]);
};

type QueryFnType = typeof getAllCostByList;

type UseGetAllCostByListOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllCostByList = ({ config }: UseGetAllCostByListOptions = {} ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllCostByList'],
    queryFn: () => getAllCostByList(),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των δεδομένων.`, 500);
      setIsNotificationVisible(true)
    }
  });
};